import React from 'react';
export const CTAButton = () => {
  return <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg shadow-lg text-base sm:text-lg uppercase tracking-wider transition-colors duration-200 w-full sm:w-auto inline-block text-center" data-id="element-260">
      DISCOVER ELIVARA & SAVE 40% TODAY →
    </a>;
};